import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { order } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false,
    orderData:[],
};


const orderSlice = createSlice({
    name: order,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
        },
        resetDetailParams: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
        setReportData: (state, action) => {
            state.orderData = action.payload
        },
    },

});


export const { setNewEntryMode, setDetailParams, resetDetailParams ,setReportData} = orderSlice.actions;
export default orderSlice.reducer;
